import React, { Component } from 'react'
import RouteManager from '../../managers/RouteManager';
import { connect, ConnectedProps } from 'react-redux';
import {fetchReportsByPage} from '../../store/slices/reportSlice'
import ReportService from '../../services/reports/Report';
import ReportHolder from './ReportHolder';
import { APPS } from '../../constants/Constant';
import { debounce, isEmpty } from '../../utilities/Common';

class Recent extends Component<PropsFromRedux, any> {
    constructor(props: any) {
        super(props)
        this.state = {
            reports: [],
            searchText: '',
            appName:''
        }

    }
    componentDidMount() {
        RouteManager.setPresenter(this);
        this.getAllReports();
    }
    getAllReports = (appName = '') => {
        let dataToSend: any = { sortBy: 'updatedDt' };
        if (!isEmpty(appName) || !isEmpty(this.state.appName)) {
            dataToSend.appName = !isEmpty(appName) ? appName : this.state.appName;
        }
        if (!isEmpty(this.state.searchText)) {
            dataToSend.search = this.state.searchText
        }
        if (!isEmpty(this.state.selectedUser)) {
            dataToSend.query = `userId=${this.state.selectedUser?.userId}`
        }
        this.props.fetchReportsByPage(dataToSend).then((response:any) => {
            this.setState({ reports: response?.payload?.content });
        })
    }
    onSearch = (searchText:any) => {
        this.setState({ searchText }, this.callDebounce)
    }
    callDebounce = debounce(() => this.getAllReports(), 300);
    render() {
        const apps = APPS.map(app => app.code);
        return (
            <ReportHolder
                headerName={'Recent Reports'}
                reports={this.state.reports}
                onDelete={() => this.getAllReports()}
                onUpdate={() => this.getAllReports()}
                onAppSelection={(index: number) => { this.setState({ appName: index === 0 ? '' : apps[index] }, () => this.getAllReports(index === 0 ? '' : apps[index])) }}
                onOwnerSelection={(user:any)=> this.setState({selectedUser:user},()=>this.getAllReports())}
                onSearch={(searchText: any) => this.onSearch(searchText)}
            />
        )
    }
}
const mapStateToProps = (state:any) => ({});
  const mapDispatchToProps = { fetchReportsByPage };
  const connector = connect(mapStateToProps, mapDispatchToProps);
  type PropsFromRedux = ConnectedProps<typeof connector>;
  export default connector(Recent);
